import { render, staticRenderFns } from "./ServerLists.vue?vue&type=template&id=218818d7&"
import script from "./ServerLists.vue?vue&type=script&lang=js&"
export * from "./ServerLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports